// adapter.ts

interface AdapterElements {
  url: string;
  type: string;
  data?: unknown;
  headers?: Record<string, string>;
}

interface AdapterError extends Error {
  status?: number;
  data?: any;
}

export default function CustomFetchAdapter(elements: AdapterElements) {
  const { url, type, data, headers } = elements;
  const controller = new AbortController();

  const fetchPromise = fetch(url, {
    method: type,
    body:
      data instanceof FormData || data instanceof URLSearchParams
        ? data
        : data
        ? JSON.stringify(data)
        : undefined,
    headers: {
      ...(headers || {}),
      ...(data && !(data instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
    },
    signal: controller.signal,
  });

  let responseCache: Response | null = null;

  return {
    async response(): Promise<Response> {
      if (!responseCache) {
        responseCache = await fetchPromise;
      }

      if (!responseCache.ok) {
        const clonedResponse = responseCache.clone();
        const errorData = await clonedResponse.json().catch(() => null);

        const error: AdapterError = new Error(
          errorData?.message || `HTTP error! status: ${responseCache.status}`
        );

        error.status = responseCache.status;
        error.data = errorData;

        throw error;
      }

      return responseCache;
    },

    async headers(): Promise<Headers> {
      if (!responseCache) {
        responseCache = await fetchPromise;
      }
      return responseCache.headers;
    },

    abort(): void {
      controller.abort();
    },
  };
}
